import './Admin.css';
import Header from '../components/Header';
import Button from '../components/Button';
import EditItems from '../components/EditItems';
import { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Admin() {

    const [whatDo, setWhatDo] = useState('');
    const [foodItems, setFoodItems] = useState([]);
    const [addingItem, setAddingItem] = useState(false);
    const [itemDeleted, setItemDeleted] = useState(false);
    const [fetchError, setFetchError] = useState(0);
    const [startDate, setStartDate] = useState(new Date('1/1/' + new Date().getFullYear()));
    const [endDate, setEndDate] = useState(new Date('12/31/' + new Date().getFullYear()));
    const [dateError, setDateError] = useState(false);
    const [stats, setStats] = useState({});

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/items`,{
            withCredentials: true,
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
                setFoodItems(data);
                setDateError(false);
            })
            .catch(err => {
                setFetchError(500);
                console.log(err);
                setDateError(true);
            });
    }, [addingItem, itemDeleted])

    

    async function addItem(name, price, mealPrice, category) {
        let newItem = { name: name, price: price, type: category, mealprice: mealPrice, deleted: false };
        if (name !== 'Item Name' && category !== 'Set Category') {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/items/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newItem),
                withCredentials: true,
                credentials: 'include',
                });
                console.log(response);
                if (!response.ok) {
                throw new Error('Network response was not ok');
                }         
                const jsonResponse = await response.json();
                console.log('POST request successful:', jsonResponse);
                setAddingItem(false);
            } catch (error) {
                console.error('POST request failed:', error);
            }
        }
    }

    async function editItem(id, name, price, mealPrice, category) {
        let editedItem = { name: name, price: price, type: category, mealprice: mealPrice, deleted: false };
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/items/${id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(editedItem),
              withCredentials: true,
              credentials: 'include',
            });
            console.log(response);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }         
            const jsonResponse = await response.json();
            console.log('POST request successful:', jsonResponse);
        } catch (error) {
            console.error('POST request failed:', error);
        }
    }

    async function deleteItem(id, name, price, category) {
        let itemToDelete = {name: name, price: price, type: category, deleted: true}
        console.log(itemToDelete);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/items/${id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(itemToDelete),
              withCredentials: true,
              credentials: 'include',
            });
            console.log(response);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }         
            const jsonResponse = await response.json();
            console.log('POST request successful:', jsonResponse);
            setItemDeleted(true);
        } catch (error) {
            console.error('POST request failed:', error);
        }
    }

    async function getStats() {
        const startDateString = startDate.toISOString().slice(0, 10);
        const endDateString = endDate.toISOString().slice(0, 10);

        try {
            await fetch(`${process.env.REACT_APP_API_URL}/orders/stats?startDate=${startDateString}&endDate=${endDateString}`, {
                withCredentials: true,
                credentials: 'include',
             })
             .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
                setStats(data);
                console.log(data);
            })
            .catch(err => {
                setFetchError(500);
                console.log(err);
            });
        } catch (error) {
            console.error('GET Request failed:', error);
        }
    }

    function getTotalByOrderType(type) {
        let total = 0;
        let arr = stats.totals;
        if (type !== 'all') arr = stats.totals.filter(i => i.ordertype === type)
        arr.forEach(i => total += parseInt(i.total));
        return total;
    }

    function getCountByOrderType(type) {
        let total = 0;
        let arr = stats.totals;
        if (type !== 'all') arr = stats.totals.filter(i => i.ordertype === type);
        arr.forEach(i => total += parseInt(i.count));
        return total;
    }

    function getCashCount(type) {
        let cashSum = 0;
        let cashItems = stats.totals.filter(i => i.paymenttype === 'cash');
        if (type !== 'all') cashItems = cashItems.filter(i => i.ordertype === type);
        cashItems.forEach(i => cashSum += parseInt(i.count));
        return cashSum;
    }

    function getMealCount(type) {
        let mealCount = 0;
        let arr = stats.counts;
        if (type !== 'all') {
            arr = arr.filter(i => i.ordertype === type && (i.foodname === 'Meal' || i.foodName === 'Worker Meal'));
        } else {
            arr = arr.filter(i => i.foodname === 'Meal' || i.foodName === 'Worker Meal')
        }
        arr.forEach(i => mealCount += parseInt(i.count));
        return mealCount;
    }

    function getMealEntreeCount(orderType, entree) {
        let count = 0;
        let arr = stats.counts;
        if (orderType !== 'all') {
            arr = arr.filter(i => i.ordertype === orderType && i.mealfoodname === entree)
        } else {
            arr = arr.filter(i => i.mealfoodname === entree)
        }
        arr.forEach(i => count += parseInt(i.count))
        return count;
    }

    function getEntreeCount(orderType, entree) {
        let count = 0;
        let arr = stats.counts;
        if (entree === 'fish') {
            arr = arr.filter(i => i.ordertype === orderType && (i.foodname === 'Cod' || i.foodname === 'Baked Cod' || i.foodname === 'Catfish'))
        } else if (orderType !== 'all') {
            arr = arr.filter(i => i.ordertype === orderType && i.foodname === entree)
        } else {
            arr = arr.filter(i => i.mealfoodname === entree)
        }
        arr.forEach(i => count += parseInt(i.count))
        return count;
    }

    function getWorkerMealCount(orderType) {
        let count = 0;
        let arr = stats.counts;
        if (orderType !== 'all') {
            arr = arr.filter(i => i.ordertype === orderType && i.foodname === 'Worker Meal')
        } else {
            arr = arr.filter(i => i.foodname === 'Worker Meal')
        }
        arr.forEach(i => count += parseInt(i.count))
        return count;
    }

    return (
        <div className='main-admin-div'>
            <Header />
            {
                whatDo === '' ? <div className='admin-main-selections'>
                    <Button buttonText='Edit food items' onClickFunction={() => setWhatDo('edit')}/>
                    <Button buttonText='See statistics' onClickFunction={() => setWhatDo('stats')}/>
                </div> : whatDo === 'edit' ? <div className='edit-main-div'>
                    <h2 className='main-edit-heading'>Edit Food Items</h2>
                    {
                        addingItem ? <EditItems name='Item Name' price={0} new={true} addItem={addItem} cancelItem={() => setAddingItem(false)}/>
                        : <Button className='new-item-button' buttonText='Add New Item' onClickFunction={() => setAddingItem(true)}/>
                    }
                    <h3>Entrees:</h3>
                    {
                        foodItems.length > 0 ? foodItems.filter(item => item.type === 'entree').map(item => 
                            <EditItems name={item.name} price={item.price} mealprice={item.mealprice} id={item.foodid} new={false} category={item.type} editItem={editItem} deleteItem={deleteItem}/>)
                            : fetchError === 0 ? <h4>Loading entrees...</h4> : <h4 style={{color: 'red'}}>Error loading entrees</h4>
                    }
                    <h3>Sides:</h3>
                    {
                        foodItems.length > 0 ? foodItems.filter(item => item.type === 'side').map(item => 
                            <EditItems name={item.name} price={item.price} id={item.foodid} new={false} category={item.type} editItem={editItem} deleteItem={deleteItem}/>)
                            : fetchError === 0 ? <h4>Loading sides...</h4> : <h4 style={{color: 'red'}}>Error loading sides</h4>
                    }
                    <h3>Extras:</h3>
                    {
                        foodItems.length > 0 ? foodItems.filter(item => item.type === 'extra').map(item => 
                            <EditItems name={item.name} price={item.price} id={item.foodid} new={false} category={item.type} editItem={editItem} deleteItem={deleteItem}/>)
                            : fetchError === 0 ? <h4>Loading extras...</h4> : <h4 style={{color: 'red'}}>Error loading extras</h4>
                    }
                    <Button buttonText='Back' onClickFunction={() => setWhatDo('')}/>
                </div> : <div className='stats-main-div'>
                    <h3 className='order-stats-header'>Order Statistics</h3>
                    <h4 className='order-stats-subheader'>Please select a date range</h4>
                    <h5 className='order-stats-sub-subheader'>(Default is all data from the current year)</h5>
                    <div className='date-options-div'>
                        <div className='datepicker-div'>
                            <DatePicker className='datepicker-object' selected={startDate} onChange={(date) => setStartDate(date)} />
                            <DatePicker className='datepicker-object' selected={endDate} onChange={(date) => setEndDate(date)} />
                        </div>
                        <Button buttonText='Get Stats for Date Range' onClickFunction={getStats}/>
                    </div>
                    {
                        dateError ? <h4 style={{color: 'red'}}>Error: Invalid date range</h4> : null
                    }
                    {
                        Object.keys(stats).length !== 0 && <div className='stats-display-div'>
                            <div className='basic-stats-display'>
                                <h2 className='stats-display-main-header'>Statistics from {startDate.toISOString().slice(0, 10)} to {endDate.toISOString().slice(0, 10)}</h2>
                                <h3 className='stats-display-header'>Overview</h3>
                                <div className='stats-items-div'>
                                    <h5 className='stats-display-item'>Dine-In Total: ${getTotalByOrderType('dinein').toFixed(2)}</h5>
                                    <h5 className='stats-display-item'>Carryout Total: ${getTotalByOrderType('takeout').toFixed(2)}</h5>
                                    <h5 className='stats-display-item'>Drive Thru Total: ${getTotalByOrderType('drivethru').toFixed(2)}</h5>
                                    <h5 className='stats-display-item'>Total: ${getTotalByOrderType('all').toFixed(2)}</h5>
                                </div>
                                <h3 className='stats-display-header'>Order Summary</h3>
                                <div className='stats-items-div stats-grid-summary'>
                                    <h5 className='stats-display-item'></h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Cash %</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Credit %</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Orders</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Meals</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Dine-In</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('dinein') > 0 ? (getCashCount('dinein')/getCountByOrderType('dinein') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('dinein') > 0 ? (100 - getCashCount('dinein')/getCountByOrderType('dinein') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('dinein')}</h5>
                                    <h5 className='stats-display-item'>{getMealCount('dinein')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Carryout</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('takeout') > 0 ? (getCashCount('takeout')/getCountByOrderType('takeout') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('takeout') > 0 ? (100 - getCashCount('takeout')/getCountByOrderType('takeout') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('takeout')}</h5>
                                    <h5 className='stats-display-item'>{getMealCount('takeout')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Drive Thru</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('drivethru') > 0 ? (getCashCount('drivethru')/getCountByOrderType('drivethru') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('drivethru') > 0 ? (100 - getCashCount('drivethru')/getCountByOrderType('drivethru') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('drivethru')}</h5>
                                    <h5 className='stats-display-item'>{getMealCount('drivethru')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Total</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('all') > 0 ? (getCashCount('all')/getCountByOrderType('all') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('all') > 0 ? (100 - getCashCount('all')/getCountByOrderType('all') * 100).toFixed(0) : 0}%</h5>
                                    <h5 className='stats-display-item'>{getCountByOrderType('all')}</h5>
                                    <h5 className='stats-display-item'>{getMealCount('all')}</h5>
                                    
                                </div>
                                <h3 className='stats-display-header'>Order Details</h3>
                                <div className='stats-items-div stats-grid-detail'>
                                    <h5 className='stats-display-item stat-grid-heading-col'></h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Cod</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Baked Cod</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Catfish</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Shrimp</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Pizza</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Extra Fish</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Extra Shrimp</h5>
                                    <h5 className='stats-display-item stat-grid-heading-col'>Worker Meals</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Dine-In</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('dinein', 'Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('dinein', 'Baked Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('dinein', 'Catfish')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('dinein', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('dinein', 'Pizza')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('dinein', 'fish')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('dinein', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getWorkerMealCount('dinein')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Carryout</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('takeout', 'Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('takeout', 'Baked Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('takeout', 'Catfish')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('takeout', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('takeout', 'Pizza')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('takeout', 'fish')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('takeout', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getWorkerMealCount('takeout')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Drive Thru</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('drivethru', 'Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('drivethru', 'Baked Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('drivethru', 'Catfish')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('drivethru', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('drivethru', 'Pizza')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('drivethru', 'fish')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('drivethru', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getWorkerMealCount('drivethru')}</h5>

                                    <h5 className='stats-display-item stat-grid-heading-row'>Total</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('all', 'Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('all', 'Baked Cod')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('all', 'Catfish')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('all', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getMealEntreeCount('all', 'Pizza')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('all', 'fish')}</h5>
                                    <h5 className='stats-display-item'>{getEntreeCount('all', 'Shrimp')}</h5>
                                    <h5 className='stats-display-item'>{getWorkerMealCount('all')}</h5>
                                </div>
                            </div>
                        </div>
                    }
                    <Button buttonText='Back' onClickFunction={() => setWhatDo('')}/>
                </div>
            }
        </div>
    )
}

export default Admin;